import { Box, Button } from '@factorialco/deprecated-design-system'
import { Form as FormObject } from 'factorial-form'
import { RejectCardDocument, RejectCardMutation } from 'generated/resources/graphql'

import TextArea from 'modules/core/components/Inputs/TextArea'
import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { canRejectCard } from 'modules/banking/lib/cards/canRejectCard'
import { BankingCard } from 'modules/banking/lib/cards/types'

interface ModalProps {
  card: BankingCard
  onClose: () => void
  onSuccess?: () => void
}

class CreateForm extends FormObject {
  constructor(values: Record<string, string>) {
    super(values, {
      reason: 'string',
    })
  }
}

export const RejectModal = ({ card, onClose, onSuccess }: ModalProps) => {
  const form = useLazyRef(() => new CreateForm({})).current

  const [rejectCard, { loading }] = useMutation(RejectCardDocument, {
    extractorFn: (data: RejectCardMutation) => data.bankingMutations.rejectBankingCard,
  })

  const companyId = useCurrentSession().company.id

  const handleSubmit = async () => {
    const res = await rejectCard({
      variables: {
        id: card.id + '',
        reason: form.get('reason').value || undefined,
        companyId: companyId,
      },
    })
    const result = handleResult(res, (errors) => {
      app.setFlash({
        type: 'wrong',
        message: errors['messages'] || i18n.t('errors.generic_error'),
      })
    })

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('expenses_v2.cards.actions.modal.reject.success'),
      })
      onSuccess?.()
    }

    onClose()
  }

  return (
    <Modal
      title={i18n.t('expenses_v2.cards.actions.modal.reject.title')}
      description={i18n.t('expenses_v2.cards.actions.modal.reject.description')}
      illustration="alert"
      onSubmit={handleSubmit}
      onClose={onClose}
      footer={
        <Box flexDirection="row" gap="s16">
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit disabled={loading || !canRejectCard(card)}>
            {i18n.t('expenses_v2.cards.actions.modal.reject.text')}
          </Button>
        </Box>
      }
    >
      <Box>
        <TextArea
          label={i18n.t('expenses_v2.forms.fields.card_rejected.label')}
          field={form.get('reason')}
        />
      </Box>
    </Modal>
  )
}
